import WidgetEditDialog from './widgetEditDialog.vue';
export default {
  name: 'AddWidgetDialog',
  components: {
    WidgetEditDialog
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    },
    dateRange: {
      type: Object,
      required: true
    },
    customParameters: {
      type: Object,
      required: true
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};